// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1xHV2","footer":"Form_footer__SsKtV"};